import React, { FC } from 'react';
import { Link } from 'react-router-dom';

export const Menu: FC = () => {
  return <div id="menu">
    <div className="pure-menu">
      <a href="/" className="pure-menu-heading">
        ZZM-CI
      </a>
      <ul className="pure-menu-list">
        <li className="pure-menu-item">
          <Link to="/" className="pure-menu-link">Dashboard</Link>
          <Link to="/stacks" className="pure-menu-link">Stacks</Link>
          <Link to="/pull-requests" className="pure-menu-link">PullRequest</Link>
        </li>
      </ul>
    </div>
  </div>;
};
